import React from 'react';
import {observer} from "mobx-react";
import {VideoSlidesArenaFiltersIndicatorBox} from './boxes/video-slides-arena-filters-indicator.box';
import {Button} from '../../../../../../basic-ui-components/button/base/button.component';
import {useServices} from '../../../../../../react-hooks/use-services.hook';
import {FlexGrowItemBox} from '../../../../../../themes/architecture/css-helpers/flex';

export const VideoSlidesArenaFiltersIndicator: React.FC = observer(() => {
    const services = useServices();


    return (
        <VideoSlidesArenaFiltersIndicatorBox>
            <FlexGrowItemBox>
                <Button
                    active
                    preset="info"
                    sizeVariant="xs"
                    margin={"0px 4px"}
                >
                    {services.translation.translate("For you")}
                </Button>
            </FlexGrowItemBox>
            <FlexGrowItemBox>
                <Button
                    active
                    preset="info"
                    sizeVariant="xs"
                    margin={"0px 4px"}
                >
                    {services.translation.translate("Fish")}
                </Button>
            </FlexGrowItemBox>
            <FlexGrowItemBox>
                <Button
                    active
                    preset="info"
                    sizeVariant="xs"
                    margin={"0px 4px"}
                >
                    {services.translation.translate("New")}
                </Button>
            </FlexGrowItemBox>
            <FlexGrowItemBox>
                <Button
                    active
                    preset="info"
                    sizeVariant="xs"
                    margin={"0px 4px"}
                >
                    {services.translation.translate("Daily Jackpot")}
                </Button>
            </FlexGrowItemBox>
            <FlexGrowItemBox>
                <Button
                    active
                    preset="info"
                    sizeVariant="xs"
                    margin={"0px 4px"}
                >
                    {services.translation.translate("Live")}
                </Button>
            </FlexGrowItemBox>

        </VideoSlidesArenaFiltersIndicatorBox>
    );
})